<figure kb-figure>
  <!-- YouTube video player -->
  @if (isExternalVideo(section)) {
    @if (youTubeVideoId$ | async; as videoId) {
      @if ((userConsent.given$ | async) === false) {
        <img class="youtube-thumbnail"
          [src]="youTubeThumbnailUrl$ | async"
          alt=""
          loading="lazy"
        >
        <app-user-consent-dialog [consent]="userConsent">
          <ng-container slot="title">{{ youTubeIntl.consent.title }}</ng-container>
          <kb-html [html]="youTubeIntl.consent.body"></kb-html>
        </app-user-consent-dialog>
      } @else {
        <iframe [src]="getYouTubeEmbedUrl(videoId) + '?modestbranding=1&autohide=1&showinfo=0&controls=1'| safe: 'resourceUrl'"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          [appEditorId]="section.editorIds?.embedUrl"
        ></iframe>
      }
    }
  }

  <!-- Self hosted video player -->
  @if (isInternalVideo(section)) {
    <kb-video
      [appEditorId]="section.editorIds?.src"
      [src]="section.attributes.src"
      [poster]="section.attributes.thumbnailSrc"
      [crop]="section.attributes.align === 'centered' ? 'both' : section.attributes.align"
      [autoplay]="section.attributes.autoplay"
      [loop]="section.attributes.loop"
    ></kb-video>
  }

  @if (attributes.caption) {
    <figcaption [appEditorId]="editorIds?.caption">
      {{attributes.caption}}
    </figcaption>
  }
</figure>
